import * as React from 'react';
import { useEffect } from 'react';
import { useSegmentResults } from '../../../hooks/useSegmentResults';
import { useBuildSegment, useBuildSegmentComposition } from '../build-segment/useBuildSegment';
import SegmentResults from './segment-results';

const SegmentResultsBuild = () => {
  const { selectedAttributes: includedAttributes } = useBuildSegment();
  const { selectedAttributes: excludedAttributes } = useBuildSegment(true);
  const { selectedComoposition: includedComposition } = useBuildSegmentComposition();
  const { selectedComoposition: excludedComposition } = useBuildSegmentComposition(true);

  const resultsQuery = useSegmentResults(
    includedAttributes,
    excludedAttributes,
    includedComposition,
    excludedComposition
  );

  useEffect(() => {
    const hasIncludeAttributes = includedAttributes?.predicates.length > 0;
    const hasExcludeAttributes = excludedAttributes?.predicates.length > 0;
    if (hasIncludeAttributes || hasExcludeAttributes) {
      resultsQuery.refetch();
    }
  }, [includedAttributes, excludedAttributes, includedComposition, excludedComposition]);

  const segmentResults = resultsQuery.data;

  return (
    <SegmentResults
      total={segmentResults?.totalCustomers || 0}
      included={segmentResults?.includedCustomers || 0}
      excluded={segmentResults?.excludedCustomers || 0}
      isLoading={resultsQuery.isFetching}
      isError={resultsQuery.isError}
      errorMessage={resultsQuery.error?.message}
      isStale={resultsQuery.isPreviousData}
    />
  );
};

export default SegmentResultsBuild;
